pyzel.team = {

	riders: function(){

		$.ajax({

			url: endpoint+'/team',
			method: 'get'

		}).done( r => {

			let col_class = '';
			let placeholder = '';
			let html = '';

			$.each( r, ( k, i ) => {								

				// top rider
				if( i.order == '1.00' ){

					col_class = 'col-sm-12';
					placeholder = 'top-rider-placeholder';

				}else{

					col_class = 'col-sm-6';
					placeholder = 'other-riders-placeholder';

				}

				html = 

				`<div class="${ col_class }">

					<a href="?page=team-rider&id=${ i.id_team }&${ pyzel.helpers.safe_name( i.name ) }" class="image-highlight">

						<div class="image">
					
							<img src="${ i.photothumb }" alt="Team">
							
						</div>

						<div class="description large">
							
							${ i.name }
							
							<div class="tagline">
								
								${ i.homebase }

							</div>

						</div>

					</a>

				</div>`;

				$( '#'+placeholder).append( html );

			})

		})

	},

	details: function( id ){		

		$.ajax({

			url: endpoint+'/team/'+id,
			method: 'get'

		}).done( r => {				

			// 404
			if( ! r.name ){				
				window.location = './?404';
				return 0;
			}			

			$('.rider-name').text( r.name );

			// improv. intro and body as they are not served from API
			// nor have standard formating, ie: paragraphs
			
			//let bio_intro = r.bio.split('.');
			//$('#description-intro').html( bio_intro[0]+'.' );
			//$('#description-body').html( r.bio.replace( bio_intro[0]+'.' , '' ) );

			//$('#bio-placeholder').html( r.bio );
			$('#bio-placeholder').html( r.description );

			//--------------------------------------------------------
			// slider - from multimedia?

			let slider_html = '';

			$.each( r.multimedia, ( k, i ) => {

				console.log( i.cmsmultimediatype );

				if( i.cmsmultimediatype != 'image' ) return 0;
				if( i.autoinclude != 1 ) return 0;

				slider_html += `

					<div class="slide">

						<div class="image">
							
							<img src="${ i.url }" alt="Slide">

						</div>
						
						<div class="description large">

							${ r.name }
						
							<div class="tagline">

								${ r.homebase }

							</div>

						</div>

					</div>`;							

			})

			$(document).trigger('team-rider-slides-loaded');

			$('#team-rider-slider').html( slider_html );
			pyzel.sliders.about(); // make dedicated slider, and call the quiver after being inited			

			//--------------------------------------------------------
			// quiver

			// now image comes from other place, the one from multimedia that is not autoinclude

			$.grep( r.multimedia, ( x )=>{

				if( x.autoinclude == 0 ){

					$('#quiver-rider-picture').css({'background-image': 'url('+x.url+')'})

				}

			})	

			// quiver boards

			let quiver_html = '';

			$.each( r.surfboardmodels, ( k, i ) => {

				let logo = $.grep( i.images, x => {

					return x.id_phototype == 419;

				})[0].photomax;

				let cover_image = $.grep( i.images, x => {

					return x.cover == 1;

				})[0].photomax;
				//})[0].image_400;

				quiver_html += `

					<li>

						<div class="col-md-2 col-sm-4 hidden-xs surfboard">
							<img src="${ cover_image }" width="250" height="825" alt="${ i.surfboardmodel }">
						</div>
						<div class="col-md-9 col-sm-8 col-xs-12">

							<div class="icon">
								<img src="${ logo }" height="81" alt="${ i.surfboardmodel }">
							</div>

							<h3>${ i.surfboardmodel }</h3>
							<div class="price">${ i.minprice } EUR</div>

							<div class="mobile">

								<img src="${ cover_image }" width="250" height="825" alt="${ i.surfboardmodel }">

							</div>

							<div class="spec-list clearfix">
								<div class="spec">
									<div class="title">Size</div>
									${ i.height }
								</div>

								<div class="spec">
									<div class="title">Width</div>
									${ i.wide }
								</div>

								<div class="spec">
									<div class="title">Thickness</div>
									${ i.thick }
								</div>

								<div class="spec">
									<div class="title">Volume</div>
									${ i.volume }L
								</div>
							</div>

							<div>

								<a href="?page=shopsurfboard&model=${ i.id_surfboardmodel }" class="btn btn-black btn-md">Buy now</a>

							</div>

						</div>

					</li>`;

			})

			$('#quiver-placeholder').html( quiver_html );
						
			let videos_html = '';

			// filter videos

			let vimeo_videos_total = 0;

			r.multimedia = $.grep( r.multimedia, ( x )=>{			
								
				return x.cmsmultimediatype == 'video';

			})

			//console.log( "r.multimedia.length" );
			//console.log( r.multimedia.length );

			let loops = 0;

			$.each( r.multimedia, ( k, i ) =>{			

				//if( i.cmsmultimediatype != 'video' ) return 0;

				//pyzel.helpers.get_video_details( 70482348 );			

				//console.log( k );
				//console.log( i );			
				
				// should be a function..
				let url_parts = i.url.split('/');				

				if( url_parts[2] != 'vimeo.com' ){

					console.log( i.url+' - sorry, vimeo videos only!');
					return 0;

				}else{

					vimeo_videos_total ++;	

				}				

				let video_id = url_parts[ url_parts.length - 1 ];
				//console.log( id );

				pyzel.vimeo.get_image( video_id ).then( function( img ){	

					loops ++;

					//console.log('vimeo returned:');
					//console.log( img );
					//console.log( img.data[0].sizes.length );
					//console.log( img.data[0].sizes[5].link );

					let video_img = img.data[0].sizes[ img.data[0].sizes.length -1 ].link;

					//return 0;				

					videos_html = `

					<div class="slide">
						<a href="#" data-vimeo-id="${ video_id }" class="js-fullwidth-video-play">
							<div class="image" style="background-image: url('${ video_img }')"></div>
							<div class="play">
								<img src="/images/play-circle.svg" width="230" height="230" class="play-circle" alt="Play">
							</div>
						</a>
					</div>`;

					$('#videos-placeholder').append( videos_html );
					
					//console.log( 'r.multimedia.length - 1' );
					//console.log( typeof ( r.multimedia.length - 1 ) );
					/*
					console.log( 'loops' );
					console.log( loops );
					console.log( 'vimeo_videos_total' );
					console.log( vimeo_videos_total );
					*/

					// this is not stable.
					if( vimeo_videos_total == loops ){

						//console.log('videos length equal current video.');
						
						pyzel.convertToSVG();
						pyzel.fullwidthVideo.init();
						pyzel.sliders.fullwidthVideo();				
						//pyzel.fullwidthVideo.init();						

					}				

				});


			})			

			//--------------------------------------------------------
			// social networks - instagram ( and others? )

		 	pyzel.social.init();

		 	pyzel.social.build_links( r.socialnetworks );

			let instagram_ids = [];

			instagram_ids[66] = 3496115;
			instagram_ids[67] = 14549197;
			instagram_ids[61] = 2908025;
			instagram_ids[63] = 12937887;
			instagram_ids[65] = 14698567;
			instagram_ids[121] = 4900407;
			instagram_ids[95] = 143930877;
			instagram_ids[120] = 13105855;
			instagram_ids[122] = 25438874;
			instagram_ids[123] = 2877810420;
			instagram_ids[64] = 477842536;
			// @thatcher.johnson: User ID: 477842536 - private
			instagram_ids[124] = 1937775322;
			instagram_ids[125] = 252595423;

			// 2877810420
			// 13105855
			//NathaN_Florence @nathan_florence: User ID: 143930877

			//4900407

			pyzel.instagram.init( instagram_ids[ id ] );

		})

		$( document ).on('team-rider-slides-loaded', ()=>{

			console.log('team-rider-slides-loaded');

			pyzel.quiver.init();
			pyzel.sliders.teamQuiver()

		});

	}
	
}	